import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { PersonTypeService } from '../../../core/services/person/person-type/person-type.service'

@Component({
  selector: 'person-type-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatFormField,
    MatInput,
    MatLabel,
  ],
  templateUrl: './person-type-create.component.html',
  styleUrl: './person-type-create.component.scss',
  providers: [PersonTypeService],
  standalone: true,
})
export class PersonTypeCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private personTypeService: PersonTypeService,
    private snackbar: SnackbarCustomService,
  ) {}

  @Output() responseCreate = new EventEmitter()

  form: FormGroup = new FormGroup({})
  loading = false

  ngOnInit(): void {
    this.createForm()
  }

  createItem() {
    this.loading = true
    const model = this.createModel()
    this.personTypeService.createPersonType(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  createModel() {
    return {
      descricao: this.form.controls['description'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: ['', [Validators.required]],
    })
  }
}
